export const getTransactionById = (transactionList, transactionId) => {
    if (transactionList && Array.isArray(transactionList)) {
        const selectOrder = transactionList.find(({ id }) => id === transactionId);

        if (selectOrder) return selectOrder;
    }

    return {};
}